module.exports = __webpack_public_path__ + "static/domobile-min-acaa16e2fccfe8574a81ac2ea328b36e.jpg";